export default __webpack_public_path__ + "images/1b28996ee96ea6fb2a0ab409bde85fda-eastern_religion.jpg";